import React from "react"
import { TCheckoutLayout } from "../../core/types/Checkout"
import CheckoutCoverImage2 from "./Layouts/Layout2/CheckoutCoverImage2"
import CheckoutCoverImageDefault from "./Layouts/LayoutDefault/CheckoutCoverImageDefault"
import CheckoutCoverImage3 from "./Layouts/Layout3/CheckoutCoverImage3"
import {
  IProductPrice,
  IProductPricePaymentInstallment,
} from "../../core/types/Product"
import CheckoutCoverImage4 from "./Layouts/Layout4/CheckoutCoverImage4"
import CheckoutCoverImage5 from "./Layouts/Layout5/CheckoutCoverImage5"
import CheckoutCoverImage6 from "./Layouts/Layout6/CheckoutCoverImage6"
import CheckoutCoverImage7 from "./Layouts/Layout7/CheckoutCoverImage7"
import { TSaleProduct } from "../../core/types/Sale"
import CheckoutCoverImage8 from "./Layouts/Layout8/CheckoutCoverImage8"

interface ICheckoutCoverImage {
  layout?: TCheckoutLayout
  imageUrl?: string
  productImageUrl?: string
  productName: string
  productDescription: string
  productInstallments: IProductPricePaymentInstallment[] | undefined
  isCheckoutBuilder: boolean
  productValue: number
  offerName: string
  data: IProductPrice | null
  products: TSaleProduct[]
  paymentMethodType: number
  paymentInstallment: number
  paymentTotal: number
  paymentValue: number
}

const CheckoutCoverImage = ({
  layout,
  imageUrl,
  productImageUrl,
  productName,
  productDescription,
  productInstallments,
  isCheckoutBuilder,
  productValue,
  offerName,
  products,
  data,
  paymentMethodType,
  paymentInstallment,
  paymentTotal,
  paymentValue,
}: ICheckoutCoverImage) => {
  if (!layout) return <></>

  const checkoutCoverImageData = {
    [TCheckoutLayout.Default]: (
      <CheckoutCoverImageDefault imageUrl={imageUrl} />
    ),
    [TCheckoutLayout.Layout2]: <CheckoutCoverImage2 imageUrl={imageUrl} />,
    [TCheckoutLayout.Layout3]: (
      <CheckoutCoverImage3
        imageUrl={imageUrl}
        productImageUrl={productImageUrl}
        productName={productName}
        productDescription={productDescription}
        productInstallments={productInstallments}
        isCheckoutBuilder={isCheckoutBuilder}
        productValue={productValue}
      />
    ),
    [TCheckoutLayout.Layout4]: <CheckoutCoverImage4 />,
    [TCheckoutLayout.Layout5]: (
      <CheckoutCoverImage5
        imageUrl={imageUrl}
        productImageUrl={productImageUrl}
        productName={productName}
        productDescription={productDescription}
        productInstallments={productInstallments}
        isCheckoutBuilder={isCheckoutBuilder}
        productValue={productValue}
        offerName={offerName}
      />
    ),
    [TCheckoutLayout.Layout6]: <CheckoutCoverImage6 />,
    [TCheckoutLayout.Layout7]: (
      <CheckoutCoverImage7
        data={data}
        products={products}
        paymentInstallment={paymentInstallment}
        paymentMethodType={paymentMethodType}
        paymentTotal={paymentTotal}
        paymentValue={paymentValue}
      />
    ),
    [TCheckoutLayout.Layout8]: <CheckoutCoverImage8 />,
  }

  return checkoutCoverImageData[layout] || <></>
}

export default CheckoutCoverImage
